export enum TrackingEvent {
  MoveToYourBoardsProjectSelected = `[Dashboards] Move to Your Boards project selected`,
}

export function track(event: TrackingEvent) {
  mixpanel.track(event);
}
